import React, {useState, useContext} from 'react'
import {EditedContext} from '../../../../partials/Context'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faX, faCheck, faFloppyDisk} from '@fortawesome/free-solid-svg-icons'
import { useEffect } from 'react';

function Availability() {
  const edited = useContext(EditedContext);
  const {setEditedItem, lawyer_data, setInputValue, updateProfile} = edited || '';
  const[edited_days, setEditedDays] = useState([]);
  const {availability} = lawyer_data || {}

  let list = []
  const [week_availability, setWeekAvailability] = useState({})

      useEffect(() => {
        setWeekAvailability(availability)
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [lawyer_data])

      const falseArr = () => {
        let edited_arr = []
        if (week_availability) {
        Object.keys(week_availability).forEach(day => {
          edited_arr.push(false)
        })
        setEditedDays(edited_arr)
        }
      }

      useEffect(() => {
        falseArr()
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [lawyer_data])

      useEffect(() => {
        convertData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
      },[week_availability])      

      if (week_availability) {
      Object.keys(week_availability).forEach((day, index) => {
        const {is_available, day_start, day_end} = week_availability[day]
        list.push(
          <div className="available-day" key={index}>
            <h3 className="day-name">{day}</h3>
            <h4 className="day-value" style={{backgroundColor: is_available || edited_days[index] === true ? '' : '#fcf8e3'}} onClick={(e) => {
                setEditedItem('availability')
                let edited_arr = edited_days
                edited_arr[index] = true
                setEditedDays([...edited_arr])
            }}>
            {edited_days[index] === true ? 
              <>
                <div className="input-hours">
                  <label>
                    Od: <input type="text" className="hour-input" value={week_availability[day].day_start} onChange={(e) => {
                        setWeekAvailability(old => {
                          return {
                            ...old,
                            [day]: {
                              ...old[day],
                              day_start: e.target.value
                            }
                          }})
                          convertData()
                    }}/>
                  </label>
                </div>
                <div className="input-hours">
                  <label>
                    Do: <input type="text"  className="hour-input" value={week_availability[day].day_end} onChange={(e) => {
                        setWeekAvailability(old => {
                        return {
                        ...old,
                        [day]: {
                          ...old[day],
                          day_end: e.target.value
                        }
                      }})
                      convertData()
                    }}/>
                  </label>
                </div>
              </>
              :
              is_available ? 
                  day_start && day_end ? `${day_start} - ${day_end}` :
                  day_start && !day_end ? `Od ${day_start}` :
                  !day_start && day_end ? `Do ${day_end}` :
                  !day_start && !day_end ? <FontAwesomeIcon icon={faCheck} className="fa-x"/> :       null 
                  : <FontAwesomeIcon icon={faX} className="fa-x"/>
            }
            
            </h4>
          </div>
        )
      })
    }

      const checkAvailability = (day) => {
        if (week_availability[day]) {
          const {day_start, day_end} = week_availability[day] || ''
          return day_start || day_end ? true : false
        } else {
          return false
        }
      }

      const regexTest = (string) => {
        if (string !== undefined) {
          if (string.length > 0) {
            let regex = new RegExp(/^[1-9][0-9]?(:[0-5][0-9])?$/)
            if ((regex).test(string)) {
              return string
            } 
          } else {
            return string
          }
        }
      }


      const convertData = () => {
        let input_value_obj = {}
        if (week_availability) {
        Object.keys(week_availability).forEach((day, index) => {
          input_value_obj = {
            ...input_value_obj,
            [day]: {
              is_available: checkAvailability(day),
              day_start: regexTest(week_availability[day].day_start),
              day_end: regexTest(week_availability[day].day_end)
            }
          }
        })

        setInputValue({availability: {...input_value_obj}})
        }
      }

  return (
    <div id="availability">
        <h3 className="title">Dostępność w tygodniu 
          {edited_days.indexOf(true) !== -1 ? 
            <button id="change-btn" onClick={() => {updateProfile();}}>
              <FontAwesomeIcon icon={faFloppyDisk} />
              <span>Zapisz</span>
            </button>
          : null
          }
          
        </h3>
        <div id="availability-content">
          {list}
        </div>
    </div>
  )
}

export default Availability